export default "__VITE_ASSET__H02nctox__"